<script setup lang="ts">
const props = defineProps<{
   contact: {
      id: number;
      first_name: string;
      last_name: string;
      email: string;
      phone_number: string;
   };
}>();

const initials = computed(() => {
   const first = props.contact.first_name?.charAt(0) || '';
   const last = props.contact.last_name?.charAt(0) || '';
   return `${first}${last}`.toUpperCase();
});
</script>

<template>
   <div v-if="contact" class="contact-card">
      <h3 class="contact-card__title">{{ $tb('public.position.questions-about-this-job') }}</h3>
      <div class="contact-card__content">
         <div class="contact-card__avatar">
            {{ initials }}
         </div>

         <div class="contact-card__info">
            <h4 class="contact-card__name">{{ contact.first_name }} {{ contact.last_name }}</h4>
            <p class="contact-card__email">
               <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
            </p>
            <p class="contact-card__phone">
               <a :href="`tel:${contact.phone_number}`">{{ contact.phone_number }}</a>
            </p>
         </div>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.contact-card {
   padding: var(--nxt-gutter-large);
   background-color: var(--nxt-light-grey);
   border-radius: var(--jobsite-border-radius, 0);
   margin: var(--nxt-gutter-large) 0;

   &__title {
      margin: 0;
      margin-bottom: var(--nxt-gutter-large);
   }

   &__content {
      display: flex;
      align-items: center;
   }

   &__avatar {
      width: 50px;
      height: 50px;
      min-width: 50px;
      border-radius: 50%;
      background-color: var(--nxt-medium-grey);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--nxt-white);
   }

   &__info {
      margin-left: var(--nxt-gutter);
   }

   h4,
   p {
      margin-top: 0;
      margin-bottom: var(--nxt-gutter-small);
   }

   p {
      margin-bottom: 0;

      a:hover {
         text-decoration: underline;
      }
   }
}
</style>
